import { Button } from '@superdispatch/ui-lab';
import { useState } from 'react';
import { ShieldAlertIcon } from 'shared/icons';
import { ShipperProfileDTO } from 'shared/modules/shipper/ShipperProfileDTO';
import { useReportedShippers } from './ReportedShippers';
import { ShipperReportingDrawer } from './shipper-reporting/ShipperReportingDrawer';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { useNavigate } from 'react-router-dom';

interface ShipperReportingBlockProps {
  shipper: ShipperProfileDTO;
}

export function ShipperReportingBlock({ shipper }: ShipperReportingBlockProps) {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { reportedShippersGUIDs } = useReportedShippers();
  const hasShipperBeenReported = reportedShippersGUIDs.includes(shipper.guid);

  return (
    <>
      {!isWebView && (
        <ShipperReportingDrawer
          shipper={shipper}
          isOpen={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
        />
      )}
      <Button
        fullWidth={true}
        variant="neutral"
        size="large"
        disabled={hasShipperBeenReported}
        endIcon={<ShieldAlertIcon />}
        onClick={() => {
          if (isWebView) {
            navigate('shipper-report');
          } else {
            setIsDrawerOpen(true);
          }
        }}
      >
        {hasShipperBeenReported ? 'Reported' : 'Report Fraud'}
      </Button>
    </>
  );
}
